/* eslint-disable no-use-before-define */
import React from 'react'
import BondSupport from './bond-support'
import GlobalSearch from './global-search'
import Messages from './messages'
import Menu from './menu'
import NavTabs from './nav-tabs'
import { show } from '../twd'
import { useAppContext } from '../App'

export default () => {

    const { view } = useAppContext()

    return <React.Fragment>
    <div className="container">
    <div className="row vertical-offset-xs"></div>
    <div className="row">
        <div className="col-xs-12 col-sm-6">
            <h1
                onClick={() => show('overview')}
            >Bond Resource Center</h1>
        </div>
        <div className="col-xs-12 col-sm-6 text-right">
            <BondSupport />
        </div>
    </div>

    { (!view || view==='overview') && <Messages />}

    <div className="row">
    <div className="col-xs-12 col-md-6">
        <GlobalSearch />
    </div>
    <div className="col-xs-12 col-md-6">
        <Menu />
    </div>
    </div>

    <NavTabs />

    </div>
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/header/header.js